import { useState } from "react";
import {Link} from "react-router-dom";
import axios from "axios";
function Post(props) {
    const item = props.iteem;
    const [url,seturl]=useState("")
    axios.get(`https://lit-fjord-67974.herokuapp.com/friends/${item.user._id}`).then((result)=>{
       seturl(`https://lit-fjord-67974.herokuapp.com/image/${result.data.photos[0].url}`)
    })
    return(
        <div className="home-item" key={item.id}>
          <div className="img-card">
          <img width="100%" height="100%" src={url} />
         <p><Link className="Link" to = {`/profile/${item.user._id}`}> {item.user.Username}</Link></p>
         </div>
          <p>{item.posts}</p>
        </div>
        
     )
}
export default Post;